import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/common/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
export default class ImpersonateModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "reason", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "reasonEnabled", void 0);
    _defineProperty(this, "reasonRequired", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    this.reason = Stream('');
    this.loading = false;
    this.reasonEnabled = app.initializers.has('fof-moderator-notes');
    this.reasonRequired = this.user.impersonateReasonRequired();
  }
  className() {
    return 'ImpersonateModal Modal--medium';
  }
  title() {
    return app.translator.trans('fof-impersonate.lib.modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", null, m("p", null, app.translator.trans('fof-impersonate.lib.modal.label', {
      username: username(this.user)
    }))), m(Form, {
      className: "Form--centered"
    }, this.reasonEnabled ? m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      value: this.reason(),
      placeholder: this.reasonRequired ? app.translator.trans('fof-impersonate.lib.modal.placeholder_required') : app.translator.trans('fof-impersonate.lib.modal.placeholder_optional'),
      oninput: withAttr('value', this.reason),
      rows: "4"
    })) : '', m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      type: 'submit',
      loading: this.loading
    }, app.translator.trans('fof-impersonate.lib.modal.impersonate_username', {
      username: username(this.user)
    })))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.store.createRecord('impersonate').save({
      userId: this.user.id(),
      reason: this.reason()
    }).then(this.attrs.callback).catch(() => {
      this.loading = false;
    });
  }
}
flarum.reg.add('fof-impersonate', 'common/components/ImpersonateModal', ImpersonateModal);